import { toast } from "react-toastify";
import { getApi, putApi, postApi, deleteApi } from "./apis";
import { Invoice } from "../screens/ServiceAgreements/types";
import { FertilizersDataRow } from "../screens/Pricing-costs/utils";
const requestCache = new Map();

const cacheKey = (endpoint: string, params?: any) => {
  return `${endpoint}${params ? JSON.stringify(params) : ""}`;
};

const withCache = async (key: string, request: () => Promise<any>) => {
  if (requestCache.has(key)) {
    return requestCache.get(key);
  }

  const promise = request();
  requestCache.set(key, promise);

  try {
    const result = await promise;
    setTimeout(() => requestCache.delete(key), 2000);
    return result;
  } catch (error) {
    requestCache.delete(key);
    throw error;
  }
};
export const fetchServiceAgreementDropdownData = async (type: string) => {
  let endpoint = "";

  switch (type) {
    case "landlord":
      endpoint = "ServiceAgreement/getAllLandLord";
      break;
    case "cropType":
      endpoint = "masterData/crop-types";
      break;
    case "jdOpsOperationType":
      endpoint = "ServiceAgreement/getAllJDOps";
      break;
    case "productorcategory":
      endpoint = "ServiceAgreement/getAllOperationProductCategories";
      break;
    default:
      throw new Error("Invalid dropdown type");
  }

  return withCache(cacheKey(endpoint), async () => {
    try {
      return await getApi(endpoint);
    } catch (error: unknown) {
      if (error instanceof Error) {
        throw new Error(`Failed to fetch data for ${type}: ${error.message}`);
      }
      throw new Error(
        `Failed to fetch data for ${type}: unknown error occurred`
      );
    }
  });
};
export const postServiceData = async (data: any) => {
  try {
    return await postApi("ServiceAgreement/AddServiceAgreementGridView", data);
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(`Failed to fetch data : ${error.message}`);
    } else {
      throw new Error("Failed to fetch data : unknown error occured");
    }
  }
};

export const fetchLandlordShareData = async (value: any) => {
  const endpoint = `ServiceAgreement/GetLandLordCostShare/${value}`;
  return withCache(cacheKey(endpoint), async () => {
    try {
      return await getApi(endpoint);
    } catch (error: unknown) {
      if (error instanceof Error) {
        throw new Error(`Failed to fetch data: ${error.message}`);
      }
      throw new Error("Failed to fetch data: unknown error occurred");
    }
  });
};

export const updateLandlordCostShare = async (data: any) => {
  try {
    return await postApi("ServiceAgreement/UpdateLandLordCostShare", data);
  } catch (error: any) {
    if (error?.response) {
      throw new Error(error.response.data?.message);
    }
    throw new Error(`Failed to fetch data : ${error.message}`);
  }
};

export const getFarmtypes = async () => {
  const endpoint = `masterdata/farms`;
  return withCache(cacheKey(endpoint), async () => {
    try {
      return await getApi(endpoint);
    } catch (error: unknown) {
      if (error instanceof Error) {
        throw new Error(`Failed to fetch data: ${error.message}`);
      }
      throw new Error("Failed to fetch data: unknown error occurred");
    }
  });
};
export const updatedServiceGrid = async (data: any) => {
  try {
    return await postApi(
      "ServiceAgreement/ApproveServiceAgreementInputShareData",
      data
    );
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(`Failed to fetch data : ${error.message}`);
    } else {
      throw new Error("Failed to fetch data : unknown error occured");
    }
  }
};

export const filterExcelData = async (data: any) => {
  try {
    return await postApi("ServiceAgreement/FilterLandLordCostShare", data);
  } catch (error: unknown) {
    if (error instanceof Error) {
      toast.error("No data please try again");
      throw new Error(`Failed to fetch data : ${error.message}`);
    } else {
      toast.error("No data please try again");
      throw new Error("Failed to fetch data : unknown error occured");
    }
  }
};

export const updateServiceGridView = async (data: any) => {
  try {
    return await putApi("ServiceAgreement/EditGridViewData", data);
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(`Failed to fetch data : ${error.message}`);
    } else {
      throw new Error("Failed to fetch data : unknown error occured");
    }
  }
};

export const bulkTransferServiceGrid = async (data: any) => {
  try {
    return await postApi("ServiceAgreement/BulkTransferData", data);
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(`Failed to fetch data : ${error.message}`);
    } else {
      throw new Error("Failed to fetch data : unknown error occured");
    }
  }
};

export const deleteServiceGridView = async (data: any) => {
  try {
    return await putApi(`ServiceAgreement/DeleteGridViewData?Id=${data}`);
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(`Failed to fetch data : ${error.message}`);
    } else {
      throw new Error("Failed to fetch data : unknown error occured");
    }
  }
};
export const fetchInputCostShareData = async (year: number) => {
  const endpoint = `ServiceAgreement/getAllInputShare?Year=${year}`;
  return withCache(cacheKey(endpoint), async () => {
    try {
      return await getApi(endpoint);
    } catch (error: unknown) {
      if (error instanceof Error) {
        throw new Error(`Failed to fetch data: ${error.message}`);
      }
      throw new Error("Failed to fetch data: unknown error occurred");
    }
  });
};

export const getFieldMappings = async () => {
  const endpoint = "FieldMapping";
  return withCache(cacheKey(endpoint), async () => {
    try {
      return await getApi(endpoint);
    } catch (error: unknown) {
      if (error instanceof Error) {
        toast.error("Failed to fetch data:");
        throw new Error(`Failed to fetch data: ${error.message}`);
      }
      throw new Error("Failed to fetch data: unknown error occurred");
    }
  });
};

export const getCropYears = async () => {
  const endpoint = `CropYear/Get`;
  return withCache(cacheKey(endpoint), async () => {
    try {
      return await getApi(endpoint);
    } catch (error: unknown) {
      if (error instanceof Error) {
        toast.error(`Failed to fetch data: ${error.message}`);
      }
      throw new Error("Failed to fetch data: unknown error occcurred");
    }
  });
};

export const getCalendarMonths = async (value: number) => {
  const endpoint = `CropYear/GetMonths/${value}`;
  return withCache(cacheKey(endpoint), async () => {
    try {
      return await getApi(endpoint);
    } catch (error: unknown) {
      if (error instanceof Error) {
        toast.error(`Failed to fetch data: ${error.message}`);
      }
      throw new Error("Failed to fetch data: unknown error occcurred");
    }
  });
};

export const getLandlordRateTypeMappings = async () => {
  const endpoint = `LandLordRateTypeMapping`;
  try {
    return await getApi(endpoint);
  } catch (error: unknown) {
    if (error instanceof Error) {
      toast.error(`Failed to fetch data: ${error.message}`);
    }
    throw new Error("Failed to fetch data: unknown error occcurred");
  }
};

export const saveLandlordRateTypeMapping = async (data: any) => {
  const endpoint = `LandLordRateTypeMapping`;
  return withCache(cacheKey(endpoint), async () => {
    try {
      return await putApi(endpoint, data);
    } catch (error: unknown) {
      if (error instanceof Error) {
        toast.error(`Failed to fetch data: ${error.message}`);
      }
      throw new Error("Failed to fetch data: unknown error occcurred");
    }
  });
};

export const getInvoicesApi = async (data: any) => {
  const endpoint = `Invoice`;
  try {
    return await postApi(endpoint, data);
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(`Failed to fetch data : ${error.message}`);
    } else {
      throw new Error("Failed to fetch data : unknown error occured");
    }
  }
};

export const getBillingEntityForLandlord = async (data: any) => {
  const endpoint = `Billing/GetBillingEntitiesForLandlords`;
  try {
    return await postApi(endpoint, data);
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(`Failed to fetch data : ${error.message}`);
    } else {
      throw new Error("Failed to fetch data : unknown error occured");
    }
  }
};

export const getJDOpsCrop = async() => {
  const endpoint = `masterdata/get-jdops-crops`;
  try {
    return await getApi(endpoint);
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(`Failed to fetch data : ${error.message}`);
    } else {
      throw new Error("Failed to fetch data : unknown error occured");
    }
  }
}

export const getFieldTypesLandlord = async (data: any) => {
  const endpoint = `Field/GetFieldsBasedOnLandlordIds`;
  try {
    return await postApi(endpoint, data);
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(`Failed to fetch data : ${error.message}`);
    } else {
      throw new Error("Failed to fetch data : unknown error occured");
    }
  }
};

export const downloadInvoiceExcel = async (id: string) => {
  const endpoint = `Invoice/download-excel/${id}`;
  try {
    return await postApi(endpoint, {}, { responseType: "blob" });
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(`Failed to download invoice : ${error.message}`);
    } else {
      throw new Error("Failed to download invoice : unknown error occured");
    }
  }
};

export const getEditDataforInvoice = async (id: string) => {
  const endpoint = `Invoice/${id}`;
  try {
    return await getApi(endpoint);
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(`Failed to fetch data : ${error.message}`);
    } else {
      throw new Error("Failed to fetch data : unknown error occured");
    }
  }
};

export const saveGridData = async (invoice: Invoice) => {
  const endpoint = `Invoice`;
  try {
    const response = await putApi(endpoint, invoice);
    if (response.status === 200) {
      toast.success("Invoice Details saved successfully.");
    }
    
    return response;
    }
    catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(`Failed to fetch data : ${error.message}`);
    } else {
      throw new Error("Failed to fetch data : unknown error occured");
    }
  }
};

export const editfertilizerData = async(data: FertilizersDataRow) => {
  const endpoint = `Fertilizer`;
  try {
      const response = await putApi(endpoint, data);
      if (response.status === 204) {
        toast.success("Row data updated successfully !");
      }
      
    return response;
    }
    catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(`Failed to fetch data : ${error.message}`);
    } else {
      throw new Error("Failed to fetch data : unknown error occured");
    }
  }
}

export const editHerbicideData = async(data: FertilizersDataRow) => {
  const endpoint = `Herbicide`;
  try {
      const response = await putApi(endpoint, data);
      if (response.status === 204) {
        toast.success("Row data updated successfully !");
      }
    return response;
    }
    catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(`Failed to fetch data : ${error.message}`);
    } else {
      throw new Error("Failed to fetch data : unknown error occured");
    }
  }
}

export const saveCustomBill = async(invoice: any) => {
  const endpoint = `Invoice/save-custom-bill`;
  try {
    const response = await postApi(endpoint, invoice);
    if (response.status === 200) {
      toast.success("Custom Bill added");
    }
    else if(response.status === 400) {
      toast.error(response.statusText);
    }
    return response;
  } catch (error: unknown) {
    
    if (error instanceof Error) {
      toast.error(error.message);
      throw new Error(`Failed to add the custom bill : ${error.message}`);
    } else {
      throw new Error("Failed to add the custom bill : unknown error occured");
    }
  }
}

export const deleteInvoiceData = async (id: string) => {
  const endpoint = `Invoice/${id}`;
  try {
    const response = await deleteApi(endpoint);
    if (response.status === 200) {
      toast.success("Invoice deleted successfully.");
    }
    return response;
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(`Failed to delete invoice : ${error.message}`);
    } else {
      throw new Error("Failed to delete invoice : unknown error occured");
    }
  }
};